// /Users/joshua.moore1153/Desktop/Sinclair Apps/spcore-v4/src/components/CcpSchoolAppsAndTesting/hooks/sendSchoolNotification.js
import { useState } from "react";
import axios from "axios";
import useAxiosConfig from "./useAxiosConfig"; // Adjust path if needed

const useSendSchoolNotification = () => {
  // Use useAxiosConfig to ensure Axios is configured with the API key
  const { loading: axiosLoading, error: axiosError } = useAxiosConfig();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendNotification = async (notificationData, subject, apiFileName) => {
    if (axiosLoading) {
      console.log("Axios not ready, waiting for API key...");
      // Optionally handle this case, e.g., by returning or throwing an error
      setError("Notification service is initializing, please wait.");
      return; // Or throw new Error("Notification service not ready");
    }
    if (axiosError) {
      console.error("Axios configuration error:", axiosError);
      setError(`Notification service error: ${axiosError}`);
      throw new Error(`Notification service error: ${axiosError}`);
    }

    setLoading(true);
    setError(null);

    try {
      // Ensure email fields have default values if missing - use real email addresses
      const sanitizedData = {
        ...notificationData,
        pathwayEmail: notificationData.pathwayEmail || "ccplus@sinclair.edu",
        opEmail: notificationData.opEmail || "ccplus@sinclair.edu",
      };

      // Construct the payload similar to other hooks
      const postDataPayload = {
        jsStruct: JSON.stringify({
          ...sanitizedData, // Spread the structured notification data
          subject: subject, // Add the subject
          apiFileName: apiFileName, // Add the API file name
        }),
      };

      // Define the endpoint for sending notifications
      // Replace '/SendSchoolNotificationEndpoint' with your actual API endpoint if different
      const endpoint = "/CcpSendSchoolNotification";

      console.log("Sending notification with payload:", postDataPayload); // Debug log
      console.log("Serialized jsStruct:", postDataPayload.jsStruct); // Additional debug log

      // Validate that we have the required fields before sending
      if (!sanitizedData.fromName || sanitizedData.fromName.trim() === "") {
        throw new Error("fromName is required for notification");
      }
      if (!sanitizedData.schoolName || sanitizedData.schoolName.trim() === "") {
        throw new Error("schoolName is required for notification");
      }
      if (!subject || subject.trim() === "") {
        throw new Error("subject is required for notification");
      }

      // Try to parse the JSON to validate it's valid
      try {
        const parsedStruct = JSON.parse(postDataPayload.jsStruct);
        console.log("Parsed jsStruct for validation:", parsedStruct);
      } catch (jsonError) {
        console.error("Invalid JSON in jsStruct:", jsonError);
        throw new Error(`Invalid JSON structure: ${jsonError.message}`);
      }

      // Use axios directly as useAxiosConfig sets up the defaults (including base URL and auth)
      const response = await axios.post(endpoint, postDataPayload);

      console.log("Notification sent successfully:", response.data); // Debug log
      setLoading(false);
      return response.data; // Return response data on success
    } catch (err) {
      console.error("Error sending school notification:", err);
      console.error("Error details:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        config: err.config,
      });
      const errorMsg =
        err.response?.data?.message ||
        err.message ||
        "Failed to send notification.";
      setError(errorMsg);
      setLoading(false);
      throw new Error(errorMsg); // Re-throw the error to be caught by the component
    }
  };

  return { sendNotification, loading, error };
};

export default useSendSchoolNotification;
